<div *ngIf="ConfigFlowTable.state === 2" class="splash empty">
	<p>{{getTranslation('Es wurden keine Daten gefunden!')}}</p>
</div>
<exg-data-list [allowSingleSelection]="false"
               [displayState]="ConfigFlowTable.state"
               [rowSource]="SummaryFlowTable.data"
               selectKey="lnkID">
	<ng-template #rowTemplate let-row>
		<div class="list-row list-single-line grid-auto-1">
			<div class="list-avatar nobackground row-span-2 app-cursor-pointer" style="cursor: pointer"
			     (click)="localConfig.openLink(row)"
			     flow="right" [tooltip]="getRessource('open')">
				<i class="fa-lg fa-duotone {{getTranslation('Icons.' + row.lnkTable)}}"></i>
			</div>
			<div class="layout-auto-1-auto-grid-1-auto grid typo-small">
				<div>
          <span class="app-list-metadata">
            {{row.Etikett}}
          </span>
					<ng-container *ngIf="row.Etikett === 'Nachricht'">
            <span flow="right" style="font-size: medium" *ngIf="row.lnkImageUrl.indexOf('In')>-1"
                  [tooltip]="getRessource('inbox')">
              <i class="app-space-left_0_25 fa-duotone fa-inbox-in typo-small"></i>
            </span>
						<span flow="right" style="font-size: medium"  *ngIf="row.lnkImageUrl.indexOf('Out')>-1"
						      [tooltip]="getRessource('inbox-out')">
              <i class="app-space-left_0_25 fa-duotone fa-inbox-out typo-small"></i>
            </span>
            <span flow="right" style="font-size: medium"  *ngIf="row.lnkImageUrl.indexOf('EXAKT')>-1"
                  [tooltip]="getRessource('location')">
              <i class="app-space-left_0_25 fa-duotone fa-location typo-small"></i>
            </span>

						<span flow="right" style="font-size: medium"  *ngIf="row.lnkImageUrl.indexOf('Done')>-1"
						      [tooltip]="getRessource('check')">
              <i class="app-space-left_0_25 fa-duotone fa-check typo-small"></i>
            </span>
            <span flow="right" style="font-size: medium"  *ngIf="row.lnkImageUrl.indexOf('Anhang')>-1"
                  [tooltip]="getRessource('attachments')">
              <i class="app-space-left_0_25 fa-duotone fa-paperclip typo-small"></i>
            </span>
            <span flow="right" class="app-list-metadata"  *ngIf="row.lnkSubTyp">
              {{row.lnkSubTyp}}
            </span>
					</ng-container>
					<ng-container *ngIf="row.Etikett === 'Aufgabe'">
            <span flow="right" style="font-size: medium" *ngIf="row.lnkImageUrl.indexOf('Done')>-1"
                  [tooltip]="getRessource('check')">
              <i class="app-space-left_0_25 fa-duotone fa-check typo-small"></i>
            </span>
					</ng-container>
				</div>
				<div class="list-metadata">
					<div class="typo-right">
						{{row.lnkCRD | excDate: 'Globals.DateTimeFormatShort'}}
					</div>
					<div class="typo-right">
						 {{row.lnkCRU}}
					</div>
				</div>
				<div class="span-2">
					<strong>{{row.lnkName}}</strong>
				</div>
				<div class="span-2 list-secondary-text"></div>
			</div>
		</div>
	</ng-template>
</exg-data-list>
